module.exports = __webpack_public_path__ + "img/texture_light.47a0c221.jpg";